import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IPost } from './post';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  public singlePost = {};
  public items = [{id: 1, zip: 80236, item: "Paint Brush", price: 4}, {id: 2, zip: 12345, item: "Easel", price: 15}, {id: 3, zip: 44444, item: "Canvas", price: 20.99}, {id: 4, zip: 91111, item: "Cup", price: 2.38}]

  public currentPostPage = 1;
  public currentMessagePage = 1;

  constructor(private http: HttpClient) { }

  getAllPosts4(val1):Observable<any> {
    const headers = {'order': 'id'}
    return this.http.get<any>(`https://excess-material.onrender.com/EM/api/all-posts-4/?page=${val1}`, { headers})
  }

  getAllPosts16(val1):Observable<any> {
    const headers = {'order': 'id'}
    return this.http.get<any>(`https://excess-material.onrender.com/EM/api/all-posts-16/?page=${val1}`, { headers})
  }

  getPricePosts4(val1, val2):Observable<any> {
    const headers = {'price': val1, 'order': 'id'}
    return this.http.get<any>(`https://excess-material.onrender.com/EM/api/price-posts-4/?page=${val2}`, { headers})
  }

  getPricePosts16(val1, val2):Observable<any> {
    const headers = {'price': val1, 'order': 'id'}
    return this.http.get<any>(`https://excess-material.onrender.com/EM/api/price-posts-16/?page=${val2}`, { headers})
  }


  getCategoryPosts4(val1, val2):Observable<any> {
    const headers = {'category': val1, 'order': 'id'}
    return this.http.get<any>(`https://excess-material.onrender.com/EM/api/category-posts-4/?page=${val2}`, { headers})
  }

  getCategoryPosts16(val1, val2):Observable<any> {
    const headers = {'category': val1, 'order': 'id'}
    return this.http.get<any>(`https://excess-material.onrender.com/EM/api/category-posts-16/?page=${val2}`, { headers})
  }

  getFilteredCategoryPosts16(val1, val2, val3):Observable<any> {
    const headers = {'category': val1, 'search': val2, 'order': 'id'}
    return this.http.get<any>(`https://excess-material.onrender.com/EM/api/filter-category-posts-16/?page=${val3}`, { headers})
  }

  getUserPosts(val1, val2):Observable<any> {
    const headers = {'userid': val1, 'order': '-id'}
    return this.http.get<any>(`https://excess-material.onrender.com/EM/api/user-posts/?page=${val2}`, { headers})
  }

  getUserMessages(val1, val2):Observable<any> {
    const headers = {'userid': val1, 'order': '-id'}
    return this.http.get<any>(`https://excess-material.onrender.com/EM/api/user-messages/?page=${val2}`, { headers})
  }


  postPost(val1, val2):Observable<any> {
    const headers = {'userid': val2}
    return this.http.post<any>(`https://excess-material.onrender.com/EM/api/add-post/`, val1, { headers })
  }

  editPost(val, ID):Observable<any> {
    return this.http.patch<any>(`https://excess-material.onrender.com/EM/api/individual-post/${ID}/`, val)
  }

  postMessage(val) {
    return this.http.post<any>('https://excess-material.onrender.com/EM/api/add-message/', val)
  }

  getSinglePost(val):Observable<any> {
    return this.http.get<any>(`https://excess-material.onrender.com/EM/api/individual-post/${val}/`)
  }

  getLocation(val1, val2,val3):Observable<any> {
    return this.http.get<any>(`https://geocode.search.hereapi.com/v1/geocode?q=${val1} ${val2}, ${val3}&apikey=_crVIx6ZCADVT626wSkPwlzS2mjn3c4BRO5nMT-MZ9Y`)
  }

  deleteMessage(ID):Observable<any> {
    return this.http.delete<any>(`https://excess-material.onrender.com/EM/api/individual-message/${ID}/`)
  }

  deletePost(ID):Observable<any> {
    return this.http.delete<any>(`https://excess-material.onrender.com/EM/api/individual-post/${ID}`)
  }
}

